<template>
  <div class="py-2 grid grid-cols-12 items-center">
    <div class="col-span-1 flex flex-col">
      <button class="flex justify-center focus:outline-none" @click="$emit('up')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 15l7-7 7 7"
          />
        </svg>
      </button>
      <button class="flex justify-center focus:outline-none" @click="$emit('down')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
    </div>
    <div class="col-span-10">
      <p class="text-sm pr-2">{{ this.processedPDF(instruction) }}</p>
      <div v-if="this.showAccounts(instruction)" class="col-span-10 text-sm p-4 bg-gray-200 mt-2">
        <p v-for="(account, idx) in this.accounts" :key="idx" v-html="account" />
      </div>
    </div>
  </div>
</template>

<script>
import { pensionInstructionMixin } from '@/app/mixins/toolkit/pension-instructions/instruction';
import { percent } from '@/app/filters/filters';

export default {
  name: 'payment-instruction-view',
  mixins: [pensionInstructionMixin],
  props: {
    instruction: {
      type: Object,
    },
  },
  computed: {
    accounts() {
      const output = [];

      this.instruction.accounts.ruleAccounts.forEach((account) => {
        let row = '';
        if (this.instruction.extra && this.instruction.extra.type === 'percentage') {
          row = `<span class="font-bold">${account.value}%</span> - `;
        }
        row += `${account.member.name} / ${account.label} / ${account.identifier} / ${(percent(account.taxFree))} tax free`;
        output.push(row);
      });
      return output;
    },
  },
};
</script>
